import axios from 'axios';
import authHeader from "@/service/auth-header";

class AppointmentService {

    async getCompanyAppointments(companyId) {
        return await axios.get(`/api/appointment1/${companyId}`, {headers: authHeader()})
    }

    async getCompanyAppointmentsLazyLoading(companyId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'scheduled';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/appointment1/lazyloading/${companyId}`;

            console.log("[AppointmentService][getCompanyAppointmentsLazyLoading]",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[ClientService][getCompanyAppointmentsLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }


    async getPractitionerAppointmentsLazyLoading(practitionerId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'scheduled';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/appointment1/practitioner/lazyloading/${practitionerId}`;

            console.log("[AppointmentService][getPractitionerAppointmentsLazyLoading]",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[AppointmentService][getPractitionerAppointmentsLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    // async getCompanyAppointmentsLazyLoading(companyId, params = {}, search = '', filters = '', start = null, end = null) {
    //     try {
    //         const queryParams = {
    //             page: params.first != null && params.rows ? params.first / params.rows + 1 : 1,
    //             size: params.rows || 10,
    //             sort: params.sortField || '',
    //             order: params.sortOrder || 'asc',
    //             search: search || '',
    //             filters: filters || ''
    //         };
    //
    //         if (start) {
    //             queryParams.start = new Date(start).toISOString();
    //         }
    //         if (end) {
    //             queryParams.end = new Date(end).toISOString();
    //         }
    //
    //         const response = await axios.get(`/api/appointment1/lazyloading/${companyId}`, {
    //             headers: authHeader(),
    //             params: queryParams
    //         });
    //
    //         return {
    //             data: response.data.content || [],
    //             totalRecords: response.data.totalElements || 0
    //         };
    //     } catch (error) {
    //         console.error("[AppointmentService][getCompanyAppointmentsLazyLoading] API Error = ", error);
    //         return { data: [], totalRecords: 0 };
    //     }
    // }


    async getPractitionerAppointments(practitionerId) {
        return await axios.get(`/api/appointment1/practitioner/${practitionerId}`, {headers: authHeader()})
    }

    async getCompanyBookings(companyId) {
        return await axios.get(`/api/appointment1/bookings/${companyId}`, {headers: authHeader()})
    }

    async getAppointment(appointmentId) {
        return await axios.get(`/api/appointment1/specific/${appointmentId}`, {headers: authHeader()})
    }

    async createAppointment(companyId, data) {
        return await axios.post(`/api/appointment1/${companyId}`, data, {headers: authHeader()});
    }

    async updateAppointment(appointmentId, data) {
        return await axios.put(`/api/appointment1/${appointmentId}`, data, {headers: authHeader()});
    }

    async deleteAppointment(appointmentId) {
        return await axios.delete(`/api/appointment1/${appointmentId}`, {headers: authHeader()})
    }

    async deleteAppointmentAll(appointmentId) {
        return await axios.delete(`/api/appointment1/all/${appointmentId}`, {headers: authHeader()})
    }

    async deleteAppointmentFuture(appointmentId) {
        return await axios.delete(`/api/appointment1/future/${appointmentId}`, {headers: authHeader()})
    }

    async createBooking(companyId, data) {
        console.log("[" + name + "][createBooking] companyId = ", companyId);
        console.log("[" + name + "][createBooking] data = ", data);

        return await axios.post(`/api/appointment1/booking/${companyId}`, data);
    }

}

export default new AppointmentService();
